import React from "react";
import { Link } from "react-router-dom";
import ROLES from "../../utils/constants";
import { getDataFromJwt, isUser, toastMaker } from "../../utils/utility";
import matrimonyInstance from "../../utils/axios";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { SHORTLIST_PROFILES } from "../../API_LIST";

function AccountsCard({
	accountsData,
	errorMessage,
	showShortList,
	isBatAccounts,
}) {
	const roleid = getDataFromJwt("role");
	const [accounts, setAccounts] = useState(null);
	function getParent() {
		if (roleid) {
			return ROLES[roleid].landingUrl;
		}
	}

	useEffect(() => {
		setAccounts(accountsData);
	}, [accountsData]);

	const parent = getParent();

	return (
		<React.Fragment>
			{accounts &&
				accounts?.map((item, index) => (
					<div className="profile-card" key={item.bat_mm_account_id}>
						<Link
							to={
								!isBatAccounts
									? `${parent}/view-account/${item.bat_mm_account_id}`
									: `${parent}/view-bat-account/${item.bat_membership_id}`
							}
							key={item.bat_mm_account_id}
						>
							<div className="d-flex gap-4 pt-10">
								<img
									src="../assets/images/bat-img/account-profile-image.svg"
									className="user-image"
									alt="Account"
								/>
								<div className="w-100">
									<div className="d-flex align-items-start justify-content-between gap-3 mb-15">
										<h5 className="tetx-blue-card">
											{item?.first_name} {item?.last_name}
										</h5>

										{isBatAccounts ? (
											<div className="d-flex gap-2">
												{item.membership_status === "in_progress" ? (
													<img
														title="Membership inactive"
														src="../assets/images/bat-img/status-pending.svg"
													/>
												) : item.membership_status === "approved" ? (
													<img
														title="Active membership"
														src="../assets/images/bat-img/status-approved.svg"
													/>
												) : item.membership_status === "declined" ? (
													<img
														title="Rejected membership"
														src="../assets/images/bat-img/status-rejected.svg"
													/>
												) : null}
											</div>
										) : (
											<div className="d-flex gap-2">
												{item.account_verification_status === "in_progress" ? (
													<img
														title="Pending verification"
														src="../assets/images/bat-img/status-pending.svg"
													/>
												) : item.account_verification_status === "approved" ? (
													<img
														title="Verified profile"
														src="../assets/images/bat-img/status-approved.svg"
													/>
												) : item.account_verification_status === "declined" ? (
													<img
														title="Rejected profile"
														src="../assets/images/bat-img/status-rejected.svg"
													/>
												) : null}
											</div>
										)}
									</div>

									<div className="d-flex gap-3 mb-10 font-14">
										<img src="../assets/images/bat-img/profile-email.svg" />
										<span>{item?.email}</span>
									</div>
								</div>
							</div>
						</Link>
					</div>
				))}
			{!accounts && !errorMessage ? <p>Loading accounts</p> : null}
			{!accounts && errorMessage ? <p>{errorMessage}</p> : null}
			{accounts?.length < 1 ? <p>No Accounts to display</p> : null}
		</React.Fragment>
	);
}

export default AccountsCard;
